import { render, staticRenderFns } from "./AppealStatusCard.component.vue?vue&type=template&id=538d8680&scoped=true"
import script from "./AppealStatusCard.component.vue?vue&type=script&lang=js"
export * from "./AppealStatusCard.component.vue?vue&type=script&lang=js"
import style0 from "./AppealStatusCard.component.vue?vue&type=style&index=0&id=538d8680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538d8680",
  null
  
)

export default component.exports